import React from "react";

export default function FallbackLoader() {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
      role="status"
      aria-live="polite">
      <div className="flex flex-col items-center gap-4">
        {/* Spinner */}
        <div className="relative w-16 h-16">
          <div className="absolute inset-0 rounded-full border-4 border-white/20"></div>
          <div className="absolute inset-0 rounded-full border-4 border-t-[#c31212] border-r-transparent border-b-transparent border-l-transparent animate-spin"></div>
        </div>

        {/* Loading text */}
        <p className="text-white font-semibold tracking-wide text-lg">
          Loading
          <span className="inline-flex w-[1.5em] text-left">
            <span className="animate-dot1 opacity-0">.</span>
            <span className="animate-dot2 opacity-0">.</span>
            <span className="animate-dot3 opacity-0">.</span>
          </span>
        </p>
      </div>

      {/* Dot animations */}
      <style>
        {`
          @keyframes dot {
            0%   { opacity: 0; }
            50%  { opacity: 1; }
            100% { opacity: 1; }
          }

          .animate-dot1 {
            animation: dot 1.4s infinite;
          }

          .animate-dot2 {
            animation: dot 1.4s infinite;
            animation-delay: 0.4s;
          }

          .animate-dot3 {
            animation: dot 1.4s infinite;
            animation-delay: 0.6s;
          }
        `}
      </style>
    </div>
  );
}
